import { Box, Container, Divider, FormControlLabel, Grid2 as Grid, Paper, Switch, Typography } from '@mui/material'
import * as React from 'react'

import UserCard from '../components/cards/UserCard'

export default function DevUserCard() {
  const [showBio, setShowBio] = React.useState(true)

  // 示例用户数据
  const sampleUsers = [
    {
      resourceId: 'user-001',
      name: '王小明',
      email: 'xiaoming@example.com',
      avatar: 'https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50',
      bio: `# 专业滑雪教练

拥有超过10年教学经验，能够教授从初学者到高级滑雪者的各个级别。

## 教学理念
- 关注个人学习风格
- 安全第一
- 渐进式技能发展

> "学习的最佳方式是在享受乐趣的同时挑战自己！"`,
      sports: ['SKI', 'SNOWBOARD'],
      certificates: ['CSIA Level 3', 'CASI Level 2'],
      certificateVerified: true,
    },
    {
      resourceId: 'user-002',
      name: '李小红',
      email: 'xiaohong@example.com',
      avatar: 'https://www.gravatar.com/avatar/305e460b479e2e5b48aec07710c08d51',
      bio: `# 单板滑雪爱好者

热爱单板滑雪的年轻教练，擅长教授基础技巧和简单的花样动作。

## 专长领域
- 初学者入门
- 基础转弯技巧
- 简单跳跃`,
      sports: ['SNOWBOARD'],
      certificates: ['CASI Level 1'],
      certificateVerified: false,
    },
    {
      resourceId: 'user-003',
      name: '张教练',
      email: 'zhang@example.com',
      bio: '资深滑雪教练，擅长教授高级技巧和速降。注重技术细节和姿势调整。',
      sports: ['SKI'],
      certificates: ['CSIA Level 4', 'Race Coach Level 2'],
      certificateVerified: true,
    },
    {
      resourceId: 'user-004',
      name: '刘新手',
      email: 'liu@example.com',
      bio: '刚开始学习滑雪，希望能够在这个冬天掌握基本技能。',
      sports: ['SKI'],
      certificates: [],
      certificateVerified: false,
    },
  ]

  return (
    <Container maxWidth="100%">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          用户卡片组件展示
        </Typography>

        <Paper sx={{ p: 2, mb: 4 }}>
          <FormControlLabel control={<Switch checked={showBio} onChange={(e) => setShowBio(e.target.checked)} />} label="显示个人简介" />
        </Paper>

        {/* 大尺寸卡片 */}
        <Typography variant="h5" gutterBottom>
          大尺寸卡片
        </Typography>
        <Grid container spacing={4} sx={{ mb: 6 }}>
          {sampleUsers.slice(0, 2).map((user) => (
            <Grid size={{ xs: 12 }} key={user.resourceId}>
              <UserCard user={user} size="large" bio={showBio} />
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* 中等尺寸卡片 */}
        <Typography variant="h5" gutterBottom>
          中等尺寸卡片
        </Typography>
        <Grid container spacing={3} sx={{ mb: 6 }}>
          {sampleUsers.map((user) => (
            <Grid size={{ xs: 12, md: 6 }} key={user.resourceId}>
              <UserCard user={user} size="medium" bio={showBio} />
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* 小尺寸卡片 */}
        <Typography variant="h5" gutterBottom>
          小尺寸卡片
        </Typography>
        <Grid container spacing={2} sx={{ mb: 6 }}>
          {sampleUsers.map((user) => (
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={user.resourceId}>
              <UserCard user={user} size="small" bio={showBio} />
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* 特殊情况展示 */}
        <Typography variant="h5" gutterBottom>
          特殊情况展示
        </Typography>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="subtitle1" gutterBottom>
              无证书用户
            </Typography>
            <UserCard
              user={{
                ...sampleUsers[3],
                certificates: [],
              }}
              bio={showBio}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="subtitle1" gutterBottom>
              无个人简介
            </Typography>
            <UserCard
              user={{
                ...sampleUsers[2],
                bio: '',
              }}
              bio={showBio}
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  )
}
